// extracted by mini-css-extract-plugin
export var formContainer = "_l4-0";
export var message = "_l4-1";